// Claude Task Types

export enum ClaudeTaskCommand {
  RUN_DIFF = "run_diff",
  SCRAPE = "scrape",
  ANALYZE = "analyze",
  EXTRACT = "run_extract",
  FIX_DIFF = "fix_diff",
  RUN_ADD = "run_add",
  RUN_ADD_PAGE = "run_add_page",
  TAG_PAGE = "tag_page",
  DISCOVERY = "discovery",
}

export enum ClaudeTaskStatus {
  PENDING = "pending",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
}

export interface ClaudeTask {
  id: string;
  command: ClaudeTaskCommand;
  params: Record<string, any>;
  status: ClaudeTaskStatus;
  result: Record<string, any> | null;
  created_at: string;
  updated_at: string;
  slug: string;
  priority: number;
  claimed_by?: string | null;
  claimed_at?: string | null;
}

export interface ClaudeTasksConnection {
  tasks: ClaudeTask[];
  totalCount: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface ClaudeTasksStatistics {
  totalTasks: number;
  pending: number;
  running: number;
  completed: number;
  failed: number;
  byCommand: ClaudeTaskCommandStats;
}

export interface ClaudeTaskCommandStats {
  run_diff: number;
  scrape: number;
  analyze: number;
  run_extract: number;
  fix_diff: number;
  run_add: number;
  run_add_page: number;
  tag_page: number;
  discovery: number;
}

export interface ClaudeTaskInput {
  command: ClaudeTaskCommand;
  slug: string;
  params: Record<string, any>;
}

export interface ClaudeTaskFilters {
  slug?: string;
  command?: ClaudeTaskCommand;
  status?: ClaudeTaskStatus[];
  created_after?: string;
  limit?: number;
  offset?: number;
}
